import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';

@customElement('info-omraade-data-element')
export class InfoOmraadeDataElement extends JobindsatsElement(LitElement) {
    @property({
        attribute: 'maaling-names',
        type: Array
    })
    maalingNames?: string[];

    @property({
        attribute: 'maaling-urls',
        type: Array
    })
    maalingUrls?: string[];

    render() {
        return this.maalingNames?.map((maalingName, index) => {
            if (this.maalingUrls) {
                return html
                    `
                    <info-accordion-element title="${maalingName}" maaling-url="${this.maalingUrls[index]}">
                    </info-accordion-element>`;
            }
        });
    };


}